import GSAP from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

GSAP.registerPlugin(ScrollTrigger)

export default class Nav {
	constructor() {
		
		this.nav 			= document.querySelector('.nav');
		this.menuButtons 	= document.querySelectorAll('[data-nav]');
		this.openMenu		= this.openMenu.bind(this)

		// HANDLE CLICKS
		this.menuButtons && this.menuButtons.forEach((menuButton)=>{
			menuButton.addEventListener('click', this.openMenu )
		})


		// DROPDOWNS
		this.menuDropdowns 			= document.querySelectorAll('.menu__dropdownlink');
		this.menuDropdownClosers 	= document.querySelectorAll('.menu__link-tab');
		this.openDropdown			= this.openDropdown.bind(this)
		this.closeDropdown			= this.closeDropdown.bind(this)

		this.menuDropdowns && this.menuDropdowns.forEach((menuDropdown)=>{
			menuDropdown.addEventListener('click', this.openDropdown )
		})
		this.menuDropdownClosers && this.menuDropdownClosers.forEach((menuDropdownCloser)=>{
			menuDropdownCloser.addEventListener('click', this.closeDropdown )
		})

		this.sticky()
		
	}

	openMenu(){

		document.querySelector('body').classList.toggle('nav--open')
		if( window.app.smoothScroll.lenis ){
			if( window.app.smoothScroll.lenis.isStopped == true ){
				window.app.smoothScroll.lenis.start()
			} else {
				window.app.smoothScroll.lenis.stop()
			}
		}
	}

	openDropdown(event){
		
		if( !event.target.parentNode.classList.contains('menu__dropdown--active') ){
			document.querySelectorAll('.menu__dropdown--active').forEach((activeDropdown) => {
				activeDropdown.classList.remove('menu__dropdown--active')
			})
		}

		event.target.parentNode.classList.toggle('menu__dropdown--active')

	}

	closeDropdown(event){

		let parent = event.target.closest('.menu__dropdown--active')
		parent && parent.classList.remove('menu__dropdown--active')

	}

	sticky()
	{
	
		// HIDING NAV ON SCROLL USING GSAP
		this.showNavAnimation = GSAP.from(this.nav, { 
			yPercent: -180,
			paused: true,
			duration: 0.1,
		}).progress(1);

		this.scrollHideStartDistance = '100px top'
		ScrollTrigger.create({
			start: this.scrollHideStartDistance,
			end: 'max',
			// toggleClass: {
			// 	targets: this.nav, 
			// 	className: 'nav--show'
			// },
			onUpdate: (self) => {
				if( self.direction === -1 ){
					this.showNavAnimation.play()
				} else {
					this.showNavAnimation.reverse()
				}
			}
		});

		this.largeHideStartDistance = '300px top'
		let tl = GSAP.timeline({
			scrollTrigger:{
				start: this.largeHideStartDistance,
				end: 'max',
				toggleClass: {
					targets: this.nav, 
					className: 'nav--show'
				},
			}
		})

	}	 
}
